'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');

module.exports = function GoldDrivePageController({config, navigatorShim, subscriptionModel, collaborationModel, pageState, s3FileModel, resourceManager, goldFileChangesModel, jsonStorage, unsavedChangesModel}, optional) {
	if (!config || !navigatorShim || !subscriptionModel || !collaborationModel || !pageState || !s3FileModel || !resourceManager || !jsonStorage || !unsavedChangesModel) {
		throw new Error('invalid-args');
	}
	const obj = observable(this),
		thumbnailBuilder = optional?.thumbnailBuilder,
		goldFileApi = (optional && optional.goldFileApi) || require('./gold-file-api'),
		GoldFileInitialiser = (optional && optional.GoldFileInitialiser) || require('./gold-file-initialiser'),
		goldFileInitialiser = new GoldFileInitialiser({config, pageState, goldFileApi, s3FileModel, collaborationModel, resourceManager, navigatorShim, goldFileChangesModel}, {thumbnailBuilder}),
		serializeContent = (optional && optional.serializeContent) || require('./serialize-content'),
		calculateFileName = (optional && optional.calculateFileName) || require('./calculate-file-name'),
		sendError = function (reason) {
			obj.dispatchEvent('error', reason);
		},
		sendTypedError = function (type) {
			return function (reason) {
				if (reason === 'network-error') {
					reason = type + '-' + reason;
				}
				sendError(reason);
			};
		},
		savePathInfo = function (fileTitle) {
			const pathInfoFromState = pageState.getPathInfo(),
				title = fileTitle || calculateFileName(collaborationModel, pathInfoFromState) || pathInfoFromState.title,
				pathInfo = Object.assign({}, pathInfoFromState, {title: title});
			return pathInfo;
		},
		saveFileComplete = function (saveConfig) {
			const savedPathInfo = pageState.applySaveConfig(saveConfig);
			if (savedPathInfo) {
				obj.dispatchEvent('fileInfo', savedPathInfo);
			}
			obj.dispatchEvent('saveFileSuccess');
			return savedPathInfo;
		},
		savingFailed = function (reason) {
			sendTypedError('save')(reason);
			return Promise.reject(reason);
		},
		saveGoldFile = async (title) => {
			if (!pageState.isInitialised) {
				sendError('invalidRequest');
				return Promise.reject('invalidRequest');
			}
			obj.dispatchEvent('savingFile');
			const pathInfo = savePathInfo(title),
				serializedContent = await serializeContent(collaborationModel.getActiveContent(), s3FileModel, resourceManager, {uploadAssets: pathInfo.uploadAssets, fileId: pathInfo.fileId}),
				saveConfiguration = await  goldFileApi.saveFile(pathInfo, serializedContent, s3FileModel),
				completeSave = async () => {
					const saveResults = await s3FileModel.savedFileInfo(saveConfiguration),
						savedPathInfo = await saveFileComplete(saveResults);
					if (thumbnailBuilder) {
						const thumbnailUrl = await thumbnailBuilder.build();
						await s3FileModel.uploadAsset(savedPathInfo.fileId, thumbnailUrl, {isThumbnail: true});
					}
					obj.dispatchEvent('goldFileSaveComplete');
				};

			if (pathInfo.new && pathInfo.title) {
				obj.dispatchEvent('renamed', pathInfo.title);
				pageState.renamed(pathInfo.title);
			}

			await completeSave();
		},
		getTrashModel = () => {
			const allowedActions = pageState && pageState.getAllowedActions();
			if (allowedActions && allowedActions.uploadChanges) {
				return goldFileChangesModel;
			}
			return s3FileModel;
		},
		checkForAnonymousFiles = () => {
			const anonymousFiles = jsonStorage.getKeysWithPrefix('_free/');
			if (anonymousFiles && anonymousFiles.length) {
				obj.dispatchEvent('hasAnonymousFiles');
			}

		};

	obj.editFileId = function (fileId) {
		navigatorShim.redirect(config.editorUrl + '/' + fileId);
	};

	obj.saveFile = function () {
		return saveGoldFile().catch((reason) => {
			if (reason === 'not-authenticated') {
				obj.dispatchEvent('saveConfirmationRequired', 'free-file');
			} else {
				return savingFailed(reason);
			}
		});
	};

	//TODO: specs or refactor
	obj.getFileKey = () => {
		const pathInfo = pageState.getPathInfo();
		return goldFileApi.goldFileKey(pathInfo);
	};
	subscriptionModel.addEventListener('subscribed expiredSubscription', async (profile) => {
		obj.dispatchEvent(profile.active ? 'goldActive' : 'goldInactive');
		try {
			const didInitialise = await goldFileInitialiser.initFile(obj.dispatchEvent);
			if (profile.active) {
				const pathInfo = pageState.getPathInfo(),
					unsaved = didInitialise && unsavedChangesModel.getUnsavedChanges();
				checkForAnonymousFiles();
				if (profile && pathInfo?.new && pathInfo?.allowedActions?.upload) {
					await saveGoldFile('An untitled mindmap');
					if (unsaved?.length) {
						unsavedChangesModel.applyUnsavedChanges(unsaved);
					}
				}

			}

		} catch (reason) {
			if (reason !== 'not-authenticated') {
				return savingFailed(reason);
			}

		}
		obj.dispatchEvent('goldFileLoadComplete');
	});

	subscriptionModel.addEventListener('not-authenticated notRegistered', () => {
		obj.dispatchEvent('goldInactive');
		goldFileInitialiser.initFile(obj.dispatchEvent);
	});

	subscriptionModel.addEventListener('goldAccountInfo', (accountInfo) => {
		if (accountInfo && accountInfo.purchaseComplete) {
			const pathInfo = pageState.getPathInfo();
			if (pathInfo && pathInfo.free) {
				return saveGoldFile('An untitled mindmap')
				.catch((reason) => {
					if (reason !== 'not-authenticated') {
						return savingFailed(reason);
					}
				});
			}
		}
	});
	subscriptionModel.addEventListener('authenticating', () => {
		obj.dispatchEvent('authenticating');
	});

	obj.redirectToDriveFileList = function () {
		navigatorShim.redirect('/files-gold.html');
	};

	obj.redirectToHomePage = function () {
		navigatorShim.redirect('/');
	};

	obj.saveFreeFile = function () {
		let contentToSave;
		if (!pageState.isInitialised) {
			sendError('invalidRequest');
			return;
		}
		const pathInfo = savePathInfo();
		obj.dispatchEvent('savingFile');
		return serializeContent(collaborationModel.getActiveContent())
		.then(s3FileModel.validFreeFileContent)
		.then(serializedContent => contentToSave = serializedContent)
		.then(() => s3FileModel.freeFileSaveConfiguration(pathInfo))
		.then((saveConfiguration) => s3FileModel.saveFreeFile(saveConfiguration, contentToSave))
		.then((saveConfiguration) => s3FileModel.savedFileInfo(saveConfiguration))
		.then(saveFileComplete)
		.then(() => {
			const newPathInfo = savePathInfo();
			if (pathInfo.free) {
				delete jsonStorage.remove(`_free/${pathInfo.fileId}`);
			}
			jsonStorage.setItem(`_free/${newPathInfo.fileId}`, {title: pathInfo.title, ts: Date.now()});
		})
		.catch(savingFailed);
	};

	obj.renameFile = function (newName) {
		obj.dispatchEvent('renamingFile');
		return Promise.resolve().then(() => {
			const pathInfo = pageState.getPathInfo();
			if (pathInfo.gold) {
				return s3FileModel.renameFile(pathInfo, newName);
			} else {
				return saveGoldFile(newName);
			}
		}).then(() => {
			obj.dispatchEvent('renamed', newName);
			pageState.renamed(newName);
			goldFileChangesModel.localControlEvent('renamed', [newName]);
			return 'renamed';
		}).catch((reason) => {
			if (reason === 'invalid-args') {
				sendError('invalidRequest');
				throw 'invalidRequest';
			}
			obj.dispatchEvent('renameFailed');
			if (reason === 'not-authorised') {
				sendError(reason);
				throw reason;
			}
			if (reason === 'not-authenticated') {
				sendError('rename-' + reason);
				throw reason;
			}
			sendError('rename-failed');
			throw reason;
		});

	};

	obj.ready = function () {
		obj.dispatchEvent('ready');
	};

	obj.trashFile = function () {
		if (!pageState.isInitialised) {
			return Promise.resolve();
		}

		const pathInfo = pageState.getPathInfo();
		obj.dispatchEvent('trashing');
		return getTrashModel().deleteFile(pathInfo)
		.then(() => {
			obj.dispatchEvent('trashed');
		})
		.catch(sendTypedError('trash'));
	};
	['trashed', 'untrashed'].forEach((evt) => {
		goldFileChangesModel.addEventListener(evt, () => obj.dispatchEvent(evt));
	});

	obj.untrashFile = function () {
		if (!pageState.isInitialised) {
			return Promise.resolve();
		}
		const pathInfo = pageState.getPathInfo();
		obj.dispatchEvent('untrashing');
		return getTrashModel().undeleteFile(pathInfo)
		.then(() => {
			obj.dispatchEvent('untrashed');
		})
		.catch(() => sendError('untrash'));
	};

	obj.requestSharingSettings = function (fileId) {
		obj.dispatchEvent('shareSettingsRequested', fileId);
	};
	obj.openHistory = function (eventId) {
		const pathInfo = pageState.getPathInfo(),
			fileId = pathInfo.fileId;
		if (eventId === undefined) {
			navigatorShim.redirect(`/history.html?fileId=${fileId}`);
		} else {
			navigatorShim.redirect(`/history.html?fileId=${fileId}&eventId=${eventId}`);
		}
	};
	obj.renameFromDefault = (newTitle) => {
		const pathInfo = pageState.getPathInfo();
		if (pathInfo && pathInfo.gold && newTitle && newTitle !== config.defaultFileTitle && pageState.getPageTitle() === config.defaultFileTitle) {
			obj.renameFile(newTitle);
		}
	};
	obj.watermarkHistory = () => s3FileModel.requestWatermark(pageState.getPathInfo());
};


